<template>
   <div class="about-eleven-section" v-if="about != null">
        <div class="eleven-promo">
            <div class="promo-carousel">
                <swiper :options="swiperOption" ref="galleryCarousel" id="elevenPromoCarousel">
                    <swiper-slide v-for="(slide, index) in about.about_eleven_gallery" :key="index">
                        <div class="pic" :style="'background-image: url(' +  slide + ')'"></div>
                        <!-- <div class="promo-set"></div> -->
                    </swiper-slide>
                </swiper>
            </div>
            <!-- <div class="promo-pic" :style="'background-image: url(' + about.about_seven_img + ')'">
            </div>
            <div class="promo-set"></div> -->
            <div class="container">
                <div class="promo-content">
                    <h4>{{about.about_eleven_section}}</h4>
                    <div class="promo-title">
                        <h2>{{about.about_eleven_title}}</h2>
                    </div>
                    <div class="promo-title-gold">
                        <h3>{{about.about_eleven_title_gold}}</h3>
                    </div>
                    <div class="promo-carousel-mobile">
                        <swiper :options="swiperOption" ref="galleryCarousel" id="elevenPromoCarousel">
                            <swiper-slide v-for="(slide, index) in about.about_eleven_gallery" :key="index">
                                <div class="pic" :style="'background-image: url(' +  slide + ')'"></div>
                                <!-- <div class="promo-set"></div> -->
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-navigation eleven-promo-carousel-navigation-mobile">
                            <div class="eleven-prev-slide slide-btn"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                            <div class="eleven-next-slide slide-btn"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                        </div>
                    </div>
                    <div class="promo-desc" v-html="about.about_eleven_desc"></div>
                    <a href="#" class="link-share">Поделиться MONACO RESIDENCE</a>
                    <div class="swiper-navigation eleven-promo-carousel-navigation">
                        <div class="eleven-prev-slide slide-btn"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                        <div class="eleven-next-slide slide-btn"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
    export default {
        name: 'about-eleven-second',
        components: {
        },
        data () {
            return {
                swiperOption: {
                    speed: 800,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    loop: true,
                    // slidesPerView: 'auto',
                    spaceBetween: 0,
                    // simulateTouch: false,
                    // pagination: {
                    //     el: '.gal-section-pagination',
                    //     type: 'fraction',
                    // },
                    navigation: {
                        nextEl: '.eleven-next-slide',
                        prevEl: '.eleven-prev-slide',
                    }
                },
            }
        },
        methods: { 
            
        },
        computed: {
            about() {
                return this.$store.state.about
            },
        },
        created () {
        },
        mounted () {
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-eleven.scss';
    // @import '@/styles/components/about/about-respond/about-elem-sixth-respond.scss';
</style>